import {
  MultiPolygon,
  Polygon,
  Point,
  MultiPoint,
  LineString,
  MultiLineString,
} from 'geojson';
import { LocationGroupFilter } from './location-group-filter';
import { MasterPlanLocation } from './master-plan-locations';
import { PlanLocationGroup } from './plan-location-group';

export class LocationGroup {
  id!: string;
  name!: string;
  locationCount!: number;
  color!: string;
  icon!: string;
  source!: string;
  filterSchema!: LocationGroupFilter[];
  geometry!:
    | MultiPolygon
    | Polygon
    | Point
    | MultiPoint
    | LineString
    | MultiLineString;
  isChecked!: boolean;
  planContainerId!: string;
  planLocationGroups!: PlanLocationGroup[];
  locations!: MasterPlanLocation[];
  isAttachedToPlan!: boolean;
  additionalData?: Record<string, string>;
}
